import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getDailyQuizQuestionsService(user) {
  return user;
  //   return axios
  //     .get(`${BASE_URL}/reference?rate=${rate.id}`)
  //     .then(({ data }) => data);
}

export function sendDailyQuizAnswerService(answer) {
  return answer;

  //   return axios
  //     .get(`${BASE_URL}/reference?rate=${rate.id}`)
  //     .then(({ data }) => data);
}

export function getDailyQuizResultsService(id) {
  return id;

  //   return axios
  //     .get(`${BASE_URL}/reference?rate=${rate.id}`)
  //     .then(({ data }) => data);
}

export function checkDailyQuizStatus() {
  return axios.get(`${BASE_URL}/checkDailyQuizStatus`).then(({ data }) => data);
}

export function checkQualDailyQuizStatus() {
  return axios
    .get(`${BASE_URL}/checkQualDailyQuizStatus`)
    .then(({ data }) => data);
}

export function loadDailyQuiz(id, isRetake) {
  return axios
    .post(`${BASE_URL}/loadDailyQuiz`, { id, isRetake })
    .then(({ data }) => data);
}

export function loadQualDailyQuiz(id, isRetake) {
  return axios
    .post(`${BASE_URL}/loadQualDailyQuiz`, { id, isRetake })
    .then(({ data }) => data);
}

export function updateDailyQuiz(
  dailyQuizId,
  dataResultsDetailed,
  isRetake = false,
) {
  return axios
    .post(`${BASE_URL}/updateDailyQuiz`, {
      dailyQuizId,
      dataResultsDetailed,
      isRetake,
    })
    .then(({ data }) => data);
}

export function updateQualDailyQuiz(
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake,
) {
  return axios
    .post(`${BASE_URL}/updateQualDailyQuiz/${qualDailyQuizId}`, {
      dataResultsDetailed,
      isRetake,
    })
    .then(({ data }) => data);
}

export function submitDailyQuiz(dailyQuizId, dataResultsDetailed, isRetake) {
  return axios
    .post(`${BASE_URL}/submitDailyQuiz`, {
      dailyQuizId,
      dataResultsDetailed,
      isRetake,
    })
    .then(({ data }) => data);
}

export function submitQualDailyQuiz(
  qualDailyQuizId,
  dataResultsDetailed,
  isRetake = false,
) {
  return axios
    .post(`${BASE_URL}/submitQualDailyQuiz/${qualDailyQuizId}`, {
      dataResultsDetailed,
      isRetake,
    })
    .then(({ data }) => data);
}
